import React from 'react'
import { array, string, number } from 'prop-types'
import {
  MarkerContainer,
  MarkerCountBackdrop,
  MarkerCount,
} from '../styles/ClustersStyles'
import { Marker } from 'react-mapbox-gl'

const RegularCluster = ({
  coordinates,
  category,
  clusterColor,
  theme,
  pointCount,
}) => (
  <Marker coordinates={coordinates} className={`clusterMarker ${category}`}>
    <MarkerContainer>
      <MarkerCountBackdrop>
        <MarkerCount bgColor={clusterColor ? clusterColor : theme}>
          {pointCount}
        </MarkerCount>
      </MarkerCountBackdrop>
    </MarkerContainer>
  </Marker>
)

RegularCluster.propTypes = {
  coordinates: array.isRequired,
  category: string.isRequired,
  theme: string.isRequired,
  pointCount: number.isRequired,
}

export default RegularCluster



// WEBPACK FOOTER //
// ./src/components/Map/Markers/RegularCluster.jsx